// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"763":"6bdb83ea","793":"a7446149"}[chunkId] + ".css";
};